// 40 communes principales de la Seine-Saint-Denis (93)
export const CITIES = [
  { name: "Montreuil", cp: "93100", quartier: "Bas-Montreuil, Centre-Ville, La Noue" },
  { name: "Saint-Denis", cp: "93200", quartier: "Centre-Ville, Pleyel, La Plaine" },
  { name: "Aulnay-sous-Bois", cp: "93600", quartier: "Centre, Mitry, Chanteloup" },
  { name: "Aubervilliers", cp: "93300", quartier: "Centre, Quatre-Chemins, Landy" },
  { name: "Drancy", cp: "93700", quartier: "Centre, Avenir Parisien, Petit-Drancy" },
  { name: "Noisy-le-Grand", cp: "93160", quartier: "Mont d'Est, Pavé Neuf, Le Champy" },
  { name: "Pantin", cp: "93500", quartier: "Quatre-Chemins, Église, Hoche" },
  { name: "Le Blanc-Mesnil", cp: "93150", quartier: "Centre, Aviation, Pont-Yblon" },
  { name: "Épinay-sur-Seine", cp: "93800", quartier: "Centre-Ville, Orgemont, La Source" },
  { name: "Bondy", cp: "93140", quartier: "Centre-Ville, Nord, Sud" },
  { name: "Bobigny", cp: "93000", quartier: "Centre, Karl Marx, Édouard Vaillant" },
  { name: "Sevran", cp: "93270", quartier: "Centre, Rougemont, Beaudottes" },
  { name: "Saint-Ouen-sur-Seine", cp: "93400", quartier: "Centre, Vieux Saint-Ouen, Docks" },
  { name: "Rosny-sous-Bois", cp: "93110", quartier: "Centre, Boissière, Pré-Gentil" },
  { name: "Livry-Gargan", cp: "93190", quartier: "Centre, Jacob, Danton" },
  { name: "Noisy-le-Sec", cp: "93130", quartier: "Centre, Boissière, Béthisy" },
  { name: "La Courneuve", cp: "93120", quartier: "Centre, 4000, Six-Routes" },
  { name: "Gagny", cp: "93220", quartier: "Centre, Maison Blanche, Jean Bouin" },
  { name: "Stains", cp: "93240", quartier: "Centre, Clos Saint-Lazare, Moulin Neuf" },
  { name: "Bagnolet", cp: "93170", quartier: "Centre, La Noue, Les Coutures" },
  { name: "Neuilly-sur-Marne", cp: "93330", quartier: "Centre, Maison Blanche, Fauvettes" },
  { name: "Tremblay-en-France", cp: "93290", quartier: "Centre, Vert-Galant, Vieux-Pays" },
  { name: "Clichy-sous-Bois", cp: "93390", quartier: "Centre, Chêne Pointu, Bois du Temple" },
  { name: "Villepinte", cp: "93420", quartier: "Centre, Vert-Galant, Parc de la Noue" },
  { name: "Pierrefitte-sur-Seine", cp: "93380", quartier: "Centre, Joncherolles, Les Poètes" },
  { name: "Les Pavillons-sous-Bois", cp: "93320", quartier: "Centre, Allées, Gare" },
  { name: "Neuilly-Plaisance", cp: "93360", quartier: "Centre, Plateau d'Avron, Maltournée" },
  { name: "Romainville", cp: "93230", quartier: "Centre, Bas-Pays, Marcel Cachin" },
  { name: "Le Pré-Saint-Gervais", cp: "93310", quartier: "Centre, Sept-Arpents, Rosenberg" },
  { name: "Les Lilas", cp: "93260", quartier: "Centre, Sente des Cornettes, Avenir" },
  { name: "Montfermeil", cp: "93370", quartier: "Centre, Bosquets, Franceville" },
  { name: "L'Île-Saint-Denis", cp: "93450", quartier: "Centre, Sud, Nord" },
  { name: "Villetaneuse", cp: "93430", quartier: "Centre, Université, Saint-Leu" },
  { name: "Le Raincy", cp: "93340", quartier: "Centre, Pavillons, Belvédère" },
  { name: "Gournay-sur-Marne", cp: "93460", quartier: "Centre, Bords de Marne, Pasteur" },
  { name: "Vaujours", cp: "93410", quartier: "Centre, Plateau, Vallée" },
  { name: "Coubron", cp: "93470", quartier: "Centre, Forêt, Mairie" },
  { name: "Villemomble", cp: "93250", quartier: "Centre, Mairie, Saint-Louis" },
  { name: "Dugny", cp: "93440", quartier: "Centre, Cité de la Comète, Bourget" },
  { name: "Le Bourget", cp: "93350", quartier: "Centre, Vieux-Bourget, Verdun" },
];

export const cityToSlug = (name) =>
  name
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/['\s]/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");

// Map slug -> city object
export const citiesBySlug = CITIES.reduce((acc, c) => {
  acc[cityToSlug(c.name)] = c;
  return acc;
}, {});
